import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { forgotPassword } from 'actions/users';
import DeviseLayout from './DeviseLayout';

class ForgotPasswordPage extends React.Component {
  static propTypes = {
    // actions
    forgotPassword: PropTypes.func.isRequired,
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.forgotPassword({ email: this.email.value });
  }

  render() {
    const { t } = this.props;
    return (
      <DeviseLayout title={t('auth.forgotPasswordTitle')} subTitle={t('auth.forgotPasswordSubtitle')} cta={t('auth.sendResetInstructions')} onSubmit={this.onSubmit}>
        <input
          name='sp-login-email'
          ref={_ref => this.email = _ref}
          autoCapitalize="none"
          type="email"
          placeholder={t('auth.email')}
        />
      </DeviseLayout>
    );
  }
}

export default connect(null, { forgotPassword })(withTranslation()(ForgotPasswordPage))
